module.exports = __webpack_public_path__ + "static/media/icon-incentive-zap.66346427.svg";